import { useState } from "react";
import { Badge, Button, Drawer, Group, Stack, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { qk } from "@/lib/apiHelpers";
import { DataTable, DataTableColumn } from "@/components/DataTable";
import type { Role, RolesListResponse } from "@/types/api";
import { RolePermissions } from "./RolePermissions";

export default function RolesPage() {
  const { data, isLoading } = useQuery({
    queryKey: qk.roles(),
    queryFn: async () => (await api.get<RolesListResponse>("/api/v1/roles")).data,
  });
  const [editing, setEditing] = useState<Role | null>(null);

  const columns: DataTableColumn<Role>[] = [
    { key: "code", header: "Код", render: (r) => <Text ff="monospace">{r.code}</Text>, width: 160 },
    { key: "name", header: "Название", render: (r) => r.name },
    {
      key: "type",
      header: "Тип",
      render: (r) => r.is_system ? <Badge color="blue" variant="light">Системная</Badge> : <Badge>Кастомная</Badge>,
      width: 130,
    },
    {
      key: "actions",
      header: "",
      width: 130,
      render: (r) => (
        <Button size="xs" variant="default" onClick={() => setEditing(r)}>Открыть</Button>
      ),
    },
  ];

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={2}>Роли и доступы</Title>
      </Group>
      <DataTable
        columns={columns}
        rows={data?.items}
        loading={isLoading}
        total={data?.items.length ?? 0}
        page={1}
        pageSize={50}
        onPageChange={() => {}}
        rowKey={(r) => r.id}
      />
      <Drawer opened={!!editing} onClose={() => setEditing(null)} title="Права роли" position="right" size="lg">
        {editing && <RolePermissions role={editing} onClose={() => setEditing(null)} />}
      </Drawer>
    </Stack>
  );
}
